export default __webpack_public_path__ + "845153a5ec7f91662d5d1e37f39ad985.svg";